<template>
	<div class="modal-container">
		<div class="modal">
			<p>
				{{ $t('deactivate_farm_error_first_part') }} {{ item_type }}
				{{ $t('deactivate_farm_error_second_part') }}
			</p>
			<div class="list">
				<ListaOrdensServico
					:ordens_servico="ordens_servico"
					:disabled_item="disabled_item"
				/>
			</div>
			<div class="container__crud__crudform__buttons">
				<a
					style="color: blue"
					@click="handleDeactivateClick"
					>{{ $t('check_service_order') }}</a
				>
				<a
					style="color: blue"
					@click="$emit('fechar_model_error')"
					>{{ $t('cancel_desactivate') }}</a
				>
			</div>
			<slot />
		</div>
	</div>
</template>

<script>
import ListaOrdensServico from '../ListServiceOrders/ListServiceOrdes.vue'

export default {
	name: 'ModalError',
	components: {
		ListaOrdensServico,
	},
	props: {
		ordens_servico: {
			type: Array,
		},
		disabled_item: {
			type: String,
			required: true,
		},
		item_type: {
			type: String,
			required: true,
		},
	},

	data() {
		return {}
	},

	watch: {},

	methods: {
		handleDeactivateClick() {
			// Converte o array para uma string JSON codificada para URL
			const ordensServicoParam = encodeURIComponent(JSON.stringify(this.ordens_servico))

			this.$router.push({
				path: '/ordemdeservico',
				query: {
					ordens_servico: ordensServicoParam,
					disabled_item: this.disabled_item,
					item_type: this.item_type,
				},
			})
		},
	},
}
</script>

<style scoped>
.modal-container {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.5); /* Fundo escuro para destacar a modal */
}

.modal {
	background-color: white;
	padding: 20px;
	border-radius: 8px;
	width: 450px;
	height: 300px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.container__crud__crudform__buttons {
	display: flex;
	justify-content: center;
	gap: 150px;
	margin-top: 20px;
}
.p {
	color: #737576;
}
</style>
